import React from 'react';
import { Chip } from '@mui/material';
import { CONFIG_STATE_LABELS } from '../../utils/configVocabulary';

export interface ZoneStatusBadgeProps {
  label: string;
  kind?: 'status' | 'snapshot' | 'policy' | 'geometry' | 'deployment';
  size?: 'small' | 'medium';
}

const toneFor = (
  kind: ZoneStatusBadgeProps['kind'],
  rawLabel: string,
): { color: 'default' | 'primary' | 'success' | 'warning' | 'error' | 'info'; variant: 'filled' | 'outlined' } => {
  const label = String(rawLabel || '').trim().toLowerCase();

  if (kind === 'snapshot' || kind === 'geometry') {
    if (label.includes(CONFIG_STATE_LABELS.missing.toLowerCase())) return { color: 'warning', variant: 'outlined' };
    if (label.includes(CONFIG_STATE_LABELS.configured.toLowerCase())) return { color: 'success', variant: 'outlined' };
  }

  if (kind === 'policy') {
    if (label.includes('no policies') || label.includes('needs policy')) {
      return { color: 'warning', variant: 'outlined' };
    }
    if (label.includes('has policies') || label.includes(CONFIG_STATE_LABELS.live.toLowerCase())) {
      return { color: 'success', variant: 'outlined' };
    }
  }

  if (kind === 'deployment') {
    if (label.includes(CONFIG_STATE_LABELS.needsAction.toLowerCase())) return { color: 'warning', variant: 'outlined' };
    if (label.includes(CONFIG_STATE_LABELS.deployed.toLowerCase())) return { color: 'success', variant: 'outlined' };
  }

  if (label === CONFIG_STATE_LABELS.live.toLowerCase()) return { color: 'success', variant: 'filled' };
  if (label === CONFIG_STATE_LABELS.draft.toLowerCase()) return { color: 'default', variant: 'outlined' };
  if (label === CONFIG_STATE_LABELS.needsAction.toLowerCase()) return { color: 'warning', variant: 'filled' };
  if (label === CONFIG_STATE_LABELS.blocked.toLowerCase()) return { color: 'error', variant: 'filled' };
  if (label === 'not deployed') return { color: 'warning', variant: 'filled' };
  if (label === CONFIG_STATE_LABELS.configured.toLowerCase()) return { color: 'success', variant: 'outlined' };

  return { color: 'default', variant: 'outlined' };
};

const ZoneStatusBadge: React.FC<ZoneStatusBadgeProps> = ({
  label,
  kind = 'status',
  size = 'small',
}) => {
  const tone = toneFor(kind, label);

  return (
    <Chip
      label={label}
      size={size}
      color={tone.color}
      variant={tone.variant}
      sx={{ fontWeight: 600 }}
    />
  );
};

export default ZoneStatusBadge;
